import DZModelMenu from "@/views/系统管理/model/DZModelMenu";
import nyNetwork from "@/api/nyBaseNetwork";
import DZModelRole from "@/views/系统管理/model/DZModelRole";
import DZModelManager from "@/views/系统管理/model/DZModelManager";
import DZModelPage from "@/model/DZModelPage";

class DZServiceManager{

    m_page = new DZModelPage(10);

    m_menu = new DZModelMenu();

    list_menu = [];

    m_role = new DZModelRole();

    list_role : Array<DZModelRole> = [];

    m_user = new DZModelManager();

    list_user : Array<DZModelManager> = [];

    /**
     * 菜单
     */
    net_get_menu(){
        nyNetwork.net("菜单列表", {} , data => {
            this.list_menu = data
        })
    }
    net_add_menu(m,success: () => void){
        nyNetwork.net("添加菜单", m , data => {
            success()
        })
    }
    net_edit_menu(m,success: () => void){
        nyNetwork.net("修改菜单", m , data => {
            success()
        })
    }
    net_opera_menu(id, success: () => void){
        nyNetwork.net("操作菜单",{ id:id }, data => {
            success()
        })
    }
    net_del_menu(id, success: () => void){
        nyNetwork.net("删除菜单",{ id:id }, data => {
            success()
        })
    }

    /**
     *  角色
     */
    net_add_role(success: () => void){
        nyNetwork.net("添加角色", this.m_role , data => {
            success()
        })
    }
    net_edit_role(success: () => void){
        nyNetwork.net("修改角色", this.m_role , data => {
            success()
        })
    }
    net_opera_role(id, success: () => void){
        nyNetwork.net("操作角色",{ id:id }, data => {
            success()
        })
    }
    net_del_role(id, success: () => void){
        nyNetwork.net("删除角色",{ id:id }, data => {
            success()
        })
    }
    net_page_role(){
        nyNetwork.net("角色分页",this.m_page, data => {
            this.list_role = data.list;
        })
    }

    net_list_role(){
        nyNetwork.net("角色列表",{}, data => {
            this.list_role = data;
            this.list_role.map(r=>{
                if(r.name == '超级管理员'){
                    r.disabled = true
                }
            })
        })
    }

    /**
     * 管理员
     */
    net_add_user(success: () => void){
        nyNetwork.net("添加管理员", this.m_user , data => {
            success()
        })
    }
    net_edit_user(success: () => void){
        nyNetwork.net("修改管理员", this.m_user , data => {
            success()
        })
    }
    net_opera_user(id, success: () => void){
        nyNetwork.net("操作管理员",{ id:id }, data => {
            success()
        })
    }
    net_del_user(id,success: () => void){
        nyNetwork.net("删除管理员",{id:id}, data => {
            success()
        })
    }
    net_page_user(){
        nyNetwork.net("管理员分页",this.m_page, data => {
            this.list_user = data.list;
        })
    }
    net_info_user(){
        nyNetwork.net("获得用户信息",{}, data => {

        })
    }
}
export default DZServiceManager;
